module.exports = __webpack_public_path__ + "img/gb.55c0f042.svg";